import React, { useEffect, useLayoutEffect, useState } from "react";
import Checkbox from "../components/Checkbox";
import { store } from "../stores/Store";
import { Modal } from "../components/Modal";
import { observer } from "mobx-react-lite";
import { Button } from "../components/Button";
import Input from "../components/Input";
import ErrorIcon from "../icons/ErrorIcon";
import { publicUrl } from "../utils/url";

import { Swiper } from "swiper";
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import './SliderModal.scss';
import { BREAKPOINT_MD } from "../stores/constants";
import OptionModel from "../models/OptionModel";
import ProductModel from "../stores/ProductModel";


function prepareHtml(item: OptionModel) {

    if (!item) {
        return '';
    }
    // replace {url} with product url
    var html = item?.learn_more || '';

    // replace {product_name} with product name
    html = html.replace(/\{product_name\}/g, item.name);
    // remove <div class="Modal__content"></div> werapper only from html. skip if not present
    if (html.includes('<div class="Modal__content">')) {
        html = html.replace(/<div class="Modal__content">(.*)<\/div>/gis, '$1')
    }

    // debugger;;

    html = html.replace(/\{url\}/g, item.url);
    return html;
}

const SliderModal = observer(() => {
    const ref = React.createRef();

    const breakpoints = {
        [BREAKPOINT_MD]: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
    };
    console.log({ breakpoints });

    useEffect(() => {
        if (ref.current) {
            const abortController = new AbortController();
            const swiperContainer = ref.current.querySelector('.swiper'); // Find the swiper container
            var swiper = new Swiper(swiperContainer, {
                modules: [Navigation],
                slidesPerView: 1,
                spaceBetween: 20,
                breakpoints: breakpoints,
                navigation: {
                    nextEl: '.SliderModal__swiper-button-next',
                    prevEl: '.SliderModal__swiper-button-prev',
                },

            });

            // loop videos
            ref.current.querySelectorAll('video').forEach(video => {
                video.addEventListener('ended', () => {
                    video.currentTime = 0;
                    video.play();
                }, { signal: abortController.signal });
                video.closest('.SliderModal__slide')?.querySelector('.video-toggle')?.addEventListener('click', () => {
                    video.paused ? video.play() : video.pause();
                }, { signal: abortController.signal });
                video.addEventListener('pause', () => {
                    video.closest('.SliderModal__slide').classList.add('paused');
                    video.closest('.SliderModal__slide').classList.remove('playing');
                }, { signal: abortController.signal });
                video.addEventListener('play', () => {
                    video.closest('.SliderModal__slide').classList.add('playing');
                    video.closest('.SliderModal__slide').classList.remove('paused');
                }, { signal: abortController.signal });
            })
            return () => {
                if (swiper) {
                    abortController.abort();
                    swiper.destroy();
                }
            }
        }

    }, [ref.current, store.isFrameDescriptionData]);


    var data: OptionModel = store.isFrameDescriptionData;

    return (
        <Modal
            className="modal-lg"
            onClose={e => {
                store.closeFrameDescription();
            }}
            isOpen={store.isFrameDescriptionOpen}

        >
            <div className="mt-4" ref={ref} dangerouslySetInnerHTML={{ __html: prepareHtml(data) }}></div>
            {/* <div className="SliderModal pt-5">

                <Swiper
                    modules={[Navigation]}
                    slidesPerView={1}
                    spaceBetween={20}
                    navigation={{
                        nextEl: '.SliderModal__swiper-button-next',
                        prevEl: '.SliderModal__swiper-button-prev',
                    }}
                    breakpoints={breakpoints}
                >
                    <SwiperSlide className="SliderModal__slide">
                        <div className="SliderModal__image"></div>
                        <div className="SliderModal__text">
                            <h1>Stelaż drewnainy</h1>
                            <h2>
                                bez pojemnika na pościel
                            </h2>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="SliderModal__slide">
                        <div className="SliderModal__image"></div>
                        <div className="SliderModal__text">
                            <p>Stelaż wykonany <b>z naturalnego, wytrzymałego drewa bukowana</b>. Starannie zaprojektowana konstrukcja gwarantuje stabliność i <b>udźwig nawet do 200kg</b>.</p>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="SliderModal__slide">
                        <div className="SliderModal__image"></div>
                        <div className="SliderModal__text">
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dignissimos earum natus vitae exercitationem, similique unde. Quae beatae dolorum, voluptatibus sint consectetur quisquam eos necessitatibus dolorem in saepe? Magni, possimus error?</p>
                        </div>
                    </SwiperSlide>
                </Swiper>
                <div className="d-flex g-2 p-2 j-end w-100">
                    <button className=" SliderModal__swiper-button-prev">
                        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.34367 7.22699L8.25391 13.1372L7.34456 14.0466L0.524982 7.22699L7.34456 0.407405L8.25391 1.31675L2.34367 7.22699Z" fill="#1F1F1F" />
                        </svg>

                    </button>
                    <button className=" SliderModal__swiper-button-next">
                        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.65633 7.77301L0.746094 1.86277L1.65544 0.95343L8.47502 7.77301L1.65544 14.5926L0.746094 13.6833L6.65633 7.77301Z" fill="#1F1F1F" />
                        </svg>

                    </button>
                </div>


            </div> */}


        </Modal>
    )
});

export default SliderModal